import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component NoteAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <NoteAddIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <NoteAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const NoteAddIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="NoteAddIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M7 14v3h3v2H7v3H5v-3.001L2 19v-2l3-.001V14h2zM19 3c1.05 0 1.918.82 1.994 1.851L21 5v10l-6 6h-3v-2h2v-5h5V5H5v7H3V5c0-1.05.82-1.918 1.851-1.994L5 3h14zm-7 8v2H8v-2h4zm5-4v2H7V7h10z"
        fillRule="evenodd"
      />
    </svg>
  )
);
NoteAddIcon.displayName = "NoteAddIcon";
export default NoteAddIcon;
